import get from 'lodash/get';
import { ContentAlignment, TableColumn, ColumnDef } from '../..';
import { CellTypeStrategy, getDefaultColumnDefParamsType } from '../models';
import { HealthCellRenderer } from './HealthCellRenderer';
import { HealthStatus } from '../../../../health';
import { DEFAULT_EMPTY_CELL_PLACEHOLDER } from '../../constants';

export class HealthCell<TData> implements CellTypeStrategy<TData> {
  public getDefaultColumnDef({
    col,
    isClientSideData,
    metadata,
  }: getDefaultColumnDefParamsType<TData>): Partial<ColumnDef<TData>> {
    return {
      valueFormatter: param => {
        const value = get(param, 'value');
        if (value == null) {
          return DEFAULT_EMPTY_CELL_PLACEHOLDER;
        }
        return String(HealthStatus[value]);
      },
      cellRenderer: HealthCellRenderer,
      width: 80, // use autoSizeStrategy after upgraded ag grid
      sortable: isClientSideData,
      // meta: {
      //   align: ContentAlignment.CENTER,
      // },
    };
  }
}
